import React, { useCallback, useState } from 'react'
import { NavBar, Popup, CheckList } from 'antd-mobile'
import { changeLanguage } from '@/store/languageSlice'
import { useDispatch } from 'react-redux'
import styles from './index.module.less'
import { useTranslation } from 'react-i18next'
import { LANGUAGE } from '@/constants'
import { useLanguage } from '@/hooks/useLanguage'
import { LanguageChangedEvents } from '@/i18n'

interface PropType {
  visible?: boolean
  onClose?: () => void
}

const Country = (props: PropType) => {
  const { visible, onClose } = props
  const { i18n, t } = useTranslation()
  const dispatch = useDispatch()
  const [slelctedLang, setSlelctedLang] = useState(i18n.language)
  const handleChangeLanguage = useCallback(
    (value) => {
      if (value.length === 0) {
        return
      }
      const cur = value[0]
      const curType = LANGUAGE.find(({ lang }) => lang === cur)

      i18n.changeLanguage(cur)
      dispatch(
        changeLanguage({
          lang: cur,
          languageType: curType.languageType,
          label: cur,
        })
      )
      setSlelctedLang(cur)
      onClose()

      try {
        Array.from(LanguageChangedEvents).forEach((trigger) => trigger(cur))
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      }
    },
    [i18n, onClose, dispatch]
  )

  const { languageList } = useLanguage()

  return (
    <Popup visible={visible} position="right" bodyStyle={{ minWidth: '100vw', overflow: 'auto' }}>
      <NavBar onBack={onClose}></NavBar>
      <div className={styles.changeLanguageBox}>
        <div className={styles.title}>{t('menu.language.change')}</div>
        <CheckList className={styles.checkList} value={[slelctedLang]} onChange={handleChangeLanguage}>
          {languageList.map((lang) => {
            return (
              <CheckList.Item key={lang.lang} value={lang.lang}>
                {lang.label}
              </CheckList.Item>
            )
          })}
        </CheckList>
      </div>
    </Popup>
  )
}

export default Country
